export default {
	data: [
		{ minFloors: 1, maxFloors: 3, cardHeight: 2 },
		{ minFloors: 4, maxFloors: 7, cardHeight: 3 },
		{ minFloors: 8, maxFloors: 10, cardHeight: 4 },
		{ minFloors: 11, maxFloors: 15, cardHeight: 5 },
		{ minFloors: 16, maxFloors: 19, cardHeight: 6 },
		{ minFloors: 20, maxFloors: 23, cardHeight: 7 },
		{ minFloors: 24, maxFloors: 99, cardHeight: 8 },
	],
	data2: [
		{ minFloors: 1, maxFloors: 3, cardHeight: 2 },
		{ minFloors: 4, maxFloors: 7, cardHeight: 3 },
		{ minFloors: 8, maxFloors: 10, cardHeight: 4 },
		{ minFloors: 11, maxFloors: 15, cardHeight: 5 },
		{ minFloors: 16, maxFloors: 19, cardHeight: 6 },
		{ minFloors: 20, maxFloors: 23, cardHeight: 7 },
		{ minFloors: 24, maxFloors: 27, cardHeight: 8 },
		{ minFloors: 28, maxFloors: 31, cardHeight: 9 },
		{ minFloors: 32, maxFloors: 35, cardHeight: 10 },
		{ minFloors: 36, maxFloors: 39, cardHeight: 11 },
		{ minFloors: 40, maxFloors: 43, cardHeight: 12 },
		{ minFloors: 44, maxFloors: 47, cardHeight: 13 },
		{ minFloors: 48, maxFloors: 51, cardHeight: 14 },
		{ minFloors: 52, maxFloors: 55, cardHeight: 15 },
		{ minFloors: 56, maxFloors: 59, cardHeight: 16 },
		{ minFloors: 60, maxFloors: 63, cardHeight: 17 },
		{ minFloors: 64, maxFloors: 67, cardHeight: 18 },
		{ minFloors: 68, maxFloors: 71, cardHeight: 19 },
		{ minFloors: 72, maxFloors: 75, cardHeight: 20 },
		{ minFloors: 76, maxFloors: 79, cardHeight: 21 },
		{ minFloors: 80, maxFloors: 83, cardHeight: 22 },
		{ minFloors: 84, maxFloors: 87, cardHeight: 23 },
		{ minFloors: 88, maxFloors: 91, cardHeight: 24 },
		{ minFloors: 92, maxFloors: 95, cardHeight: 25 },
		{ minFloors: 96, maxFloors: 99, cardHeight: 26 },
		{ minFloors: 100, maxFloors: 103, cardHeight: 27 },
	],
	data3: [
		{ floors: 1, cardHeight: 8.5 },
		{ floors: 2, cardHeight: 9.8 },
		{ floors: 3, cardHeight: 11 },
		{ floors: 4, cardHeight: 12.2 },
		{ floors: 5, cardHeight: 13.3 },
		{ floors: 6, cardHeight: 14.5 },
		{ floors: 7, cardHeight: 15.7 },
		{ floors: 8, cardHeight: 16.9 },
		{ floors: 9, cardHeight: 18 },
		{ floors: 10, cardHeight: 19.2 },
		{ floors: 11, cardHeight: 20.5 },
		{ floors: 12, cardHeight: 21.6 },
		{ floors: 13, cardHeight: 22.8 },
		{ floors: 14, cardHeight: 24 },
		{ floors: 15, cardHeight: 25.2 },
		{ floors: 16, cardHeight: 26.4 },
		{ floors: 17, cardHeight: 27.6 },
		{ floors: 18, cardHeight: 28.8 },
		{ floors: 19, cardHeight: 30 },
		{ floors: 20, cardHeight: 31.2 },
		{ floors: 21, cardHeight: 32.4 },
		{ floors: 22, cardHeight: 33.6 },
		{ floors: 23, cardHeight: 34.8 },
		{ floors: 24, cardHeight: 36 },
		{ floors: 25, cardHeight: 37.2 },
		{ floors: 26, cardHeight: 38.4 },
		{ floors: 27, cardHeight: 39.6 },
		{ floors: 28, cardHeight: 40.8 },
		{ floors: 29, cardHeight: 42 },
		{ floors: 30, cardHeight: 43.2 },
		{ floors: 31, cardHeight: 44.4 },
		{ floors: 32, cardHeight: 45.6 },
		{ floors: 33, cardHeight: 46.8 },
		{ floors: 34, cardHeight: 48 },
		{ floors: 35, cardHeight: 49.2 },
		{ floors: 36, cardHeight: 50.4 },
		{ floors: 37, cardHeight: 51.6 },
		{ floors: 38, cardHeight: 52.8 },
		{ floors: 39, cardHeight: 54 },
		{ floors: 40, cardHeight: 55.2 },
		{ floors: 41, cardHeight: 56.4 },
		{ floors: 42, cardHeight: 57.6 },
		{ floors: 43, cardHeight: 58.8 },
		{ floors: 44, cardHeight: 60 },
		{ floors: 45, cardHeight: 61.2 },
		{ floors: 46, cardHeight: 62.4 },
		{ floors: 47, cardHeight: 63.6 },
		{ floors: 48, cardHeight: 64.8 },
		{ floors: 49, cardHeight: 66 },
		{ floors: 50, cardHeight: 67.2 },
		{ floors: 51, cardHeight: 68.4 },
		{ floors: 52, cardHeight: 69.6 },
		{ floors: 53, cardHeight: 70.8 },
		{ floors: 54, cardHeight: 72 },
		{ floors: 55, cardHeight: 73.2 },
		{ floors: 56, cardHeight: 74.4 },
		{ floors: 57, cardHeight: 75.6 },
		{ floors: 58, cardHeight: 76.8 },
		{ floors: 59, cardHeight: 78 },
		{ floors: 60, cardHeight: 79.2 },
		{ floors: 61, cardHeight: 80.4 },
		{ floors: 62, cardHeight: 81.6 },
		{ floors: 63, cardHeight: 82.8 },
		{ floors: 64, cardHeight: 84 },
		{ floors: 65, cardHeight: 85.2 },
		{ floors: 66, cardHeight: 86.4 },
		{ floors: 67, cardHeight: 87.6 },
		{ floors: 68, cardHeight: 88.8 },
		{ floors: 69, cardHeight: 90 },
		{ floors: 70, cardHeight: 91.2 },
		{ floors: 71, cardHeight: 92.4 },
		{ floors: 72, cardHeight: 93.6 },
		{ floors: 73, cardHeight: 94.8 },
		{ floors: 74, cardHeight: 96 },
		{ floors: 75, cardHeight: 97.2 },
		{ floors: 76, cardHeight: 98.4 },
		{ floors: 77, cardHeight: 99.6 },
		{ floors: 78, cardHeight: 100.8 },
		{ floors: 79, cardHeight: 102 },
		{ floors: 80, cardHeight: 103.2 },
		{ floors: 81, cardHeight: 104.4 },
		{ floors: 82, cardHeight: 105.6 },
		{ floors: 83, cardHeight: 106.8 },
		{ floors: 84, cardHeight: 108 },
		{ floors: 85, cardHeight: 109.2 },
		{ floors: 86, cardHeight: 110.4 },
		{ floors: 87, cardHeight: 111.6 },
		{ floors: 88, cardHeight: 112.8 },
		{ floors: 89, cardHeight: 114 },
		{ floors: 90, cardHeight: 115.2 },
		{ floors: 91, cardHeight: 116.4 },
		{ floors: 92, cardHeight: 117.6 },
		{ floors: 93, cardHeight: 118.8 },
		{ floors: 94, cardHeight: 120 },
		{ floors: 95, cardHeight: 121.2 },
		{ floors: 96, cardHeight: 122.4 },
		{ floors: 97, cardHeight: 123.6 },
		{ floors: 98, cardHeight: 124.8 },
		{ floors: 99, cardHeight: 126 },
		{ floors: 100, cardHeight: 127.2 },
	],
	data4: [
		{ units: 1, cardWidth: 45 },
		{ units: 2, cardWidth: 50 },
		{ units: 3, cardWidth: 60 },
		{ units: 4, cardWidth: 70 },
		{ units: 5, cardWidth: 80 },
		{ units: 6, cardWidth: 85 },
		{ units: 7, cardWidth: 95 },
		{ units: 8, cardWidth: 100 },
		{ units: 9, cardWidth: 105 },
		{ units: 10, cardWidth: 120 },
		{ units: 11, cardWidth: 130 },
		{ units: 12, cardWidth: 140 },
		{ units: 13, cardWidth: 150 },
		{ units: 14, cardWidth: 160 },
		{ units: 15, cardWidth: 170 },
		{ units: 16, cardWidth: 180 },
		{ units: 17, cardWidth: 190 },
		{ units: 18, cardWidth: 200 },
		{ units: 19, cardWidth: 210 },
		{ units: 20, cardWidth: 220 },
		{ units: 21, cardWidth: 230 },
		{ units: 22, cardWidth: 240 },
		{ units: 23, cardWidth: 250 },
		{ units: 24, cardWidth: 260 },
		{ units: 25, cardWidth: 270 },
		{ units: 26, cardWidth: 280 },
		{ units: 27, cardWidth: 290 },
		{ units: 28, cardWidth: 300 },
		{ units: 29, cardWidth: 310 },
		{ units: 30, cardWidth: 320 },
	],
};
